var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 26.25H6.25C4.875 26.25 3.75 25.125 3.75 23.75V6.25C3.75 4.875 4.875 3.75 6.25 3.75H11.25C12.625 3.75 13.75 4.875 13.75 6.25V23.75C13.75 25.125 12.625 26.25 11.25 26.25ZM18.75 26.25H23.75C25.125 26.25 26.25 25.125 26.25 23.75V17.5C26.25 16.125 25.125 15 23.75 15H18.75C17.375 15 16.25 16.125 16.25 17.5V23.75C16.25 25.125 17.375 26.25 18.75 26.25ZM26.25 10V6.25C26.25 4.875 25.125 3.75 23.75 3.75H18.75C17.375 3.75 16.25 4.875 16.25 6.25V10C16.25 11.375 17.375 12.5 18.75 12.5H23.75C25.125 12.5 26.25 11.375 26.25 10Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5c8906a6c855eb21f30d07d624d0e163.svg";
export { ForwardRef as ReactComponent };